import { useEffect } from "react";


export default function InstagramFeeds() {

  useEffect(() => {
    const hide = () => {
      const selectors = [
        'a[href*="elfsight.com"]',
        '.eapps-instagram-feed-data-status-container',
        '.eapps-instagram-feed-data-status',
        '.eapps-instagram-feed-title-container',
      ];
      selectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          el.style.setProperty('display', 'none', 'important');
          el.style.setProperty('visibility', 'hidden', 'important');
          el.style.setProperty('height', '0', 'important');
          el.style.setProperty('overflow', 'hidden', 'important');
        });
      });
    };

    hide();
    const interval = setInterval(hide, 500);
    setTimeout(() => clearInterval(interval), 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section className="ig-section">
        <div className="ig-header">
          <div className="ig-eyebrow">
            <span className="ig-eyebrow-line" />
            Follow Us
            <span className="ig-eyebrow-line" />
          </div>
          <h2 className="ig-title">
            Our <span>Instagram</span> Feed
          </h2>
        </div>

        <div
          className="elfsight-app-b2354471-3fb3-4689-967c-151c65c63204"
          data-elfsight-app-lazy
        ></div>
      </section>
    </>
  );
}
